import * as HLF from "html-living-framework";
import { Application } from "../Application";
import { CaptionToken } from "../Data/CaptionToken";
import * as Topics from "../Data/Topics";

export enum InteruptType {
    EQUAL,
    LESS,
    NONE,
    NUM_ELEMENTS,
}

export enum VoiceCategory {
    GAMEPLAY,
    UI,
    FUN_FACT,
    INSTRUCTIONAL,
    NUM_ELEMENTS,
}

export class VoiceOverManager {
    private _activeKey: string | undefined;
    private _activePriority: number;

    private _subscriptions: any[];

    constructor() {
        this._activePriority = -1;

        this._subscriptions = new Array<any>();
        this._subscriptions.push(PubSub.subscribe(
            HLF.STATE_TRANSITION,
            this.onStateTransition.bind(this),
        ));
    }

    private get activeVO(): HLF.HowlerTrack | undefined {
        if (this._activeKey !== undefined) {
            return Application.instance.audio.getAudioTrack(this._activeKey, HLF.AudioCategory.VO) as HLF.HowlerTrack;
        }
        return undefined;
    }

    public play(pKey: string, pInterupt: InteruptType = InteruptType.NONE, pPriority: number = -1): boolean {
        const active: HLF.HowlerTrack | undefined = this.activeVO;
        // Determine if this call should be ignored due to an existing VO line with greater priority
        if (active !== undefined && active.isPlaying() && this._activePriority !== -1) {
            if (this._activeKey === pKey) {
                return false;
            }
            else if (pInterupt === InteruptType.LESS && this._activePriority >= pPriority) {
                return false;
            }
            else if (pInterupt === InteruptType.EQUAL && this._activePriority > pPriority) {
                return false;
            }
        }

        // Clean up any existing VO files
        this.killActive();

        this._activeKey = pKey;
        this._activePriority = pPriority;
        Application.instance.audio.load(pKey, HLF.AudioCategory.VO, () => {
            Application.instance.audio.play(pKey, 0.4, false, HLF.AudioCategory.VO);
            PubSub.publishSync(Topics.PLAY_CAPTION, new CaptionToken(pKey));
        });
        return true;
    }

    public destroy(): void {
        for (let i = 0; i < this._subscriptions.length; ++i) {
            PubSub.unsubscribe(this._subscriptions[i]);
        }
    }

    private killActive(): void {
        const active: HLF.HowlerTrack | undefined = this.activeVO;
        if (active !== undefined) {
            switch (active.getSource().state()) {
                case HLF.HowlerUtils.State.LOADED:
                    if (active.isPlaying) {
                        active.fadeTo(0, 250);
                        PubSub.publishSync(Topics.STOP_CAPTION, undefined);
                    }
                    break;
                case HLF.HowlerUtils.State.LOADING:
                    active.stop();
                    break;
            }
        }
        this._activeKey = undefined;
    }

    private onStateTransition(): void {
        this.killActive();
    }
}
